import {NiceModalForm} from "../../components/Modals";
import NiceModal from "@ebay/nice-modal-react";
import {observer} from "mobx-react"; // Added icons for switch
import React, {useState, useEffect} from 'react';
import {
  Row,
  Col,
  Card,
  Radio,
  Table,
  Input,
  Typography,
  Space,
  Form,
  notification,
} from 'antd';
import {Showable, Switch2} from "../../components/Switcher";
import {BoldLinkOnlyEditor} from "../../components/RichEditor";
import {callWithCatch, pp, tourneyUrl} from "../../utils";
import Tourney from "../tourney/Tourney";

const {Text} = Typography; // Use Text instead of Title if needed

const SelectableTable = ({ value, onChange, data, columns }) => {
  // Configure row selection
  const rowSelection = {
    type: 'checkbox', // Use checkboxes for selection
    selectedRowKeys: value, // Controlled by the Form.Item's value
    onChange: (selectedRowKeys) => {
      // Call the Form.Item's onChange handler when selection changes
      if (onChange) {
        onChange(selectedRowKeys);
      }
    },
  };

  return (
    <Table
      rowSelection={rowSelection}
      columns={columns}
      dataSource={data}
      rowKey="id" // Crucial: Specify the unique key property
      pagination={false} // Optional: Hide pagination for simplicity
      size="small" // Optional: Make table smaller
    />
  );
};

let EmailTool = ({form}) => {
  const [loading, setLoading] = useState([]);
  const [divs, setDivs] = useState([]);
  const [players, setPlayers] = useState([]);
  const [isTestMode, setIsTestMode] = useState(false);

  // --- Core Logic: Update Recipient List ---
  // const updateplayers = useCallback(() => {
  // }, [selectedGroupIds, selectedStatusFilter, isTestMode]);

  // --- Effect to Trigger Update ---
  useEffect(() => {
    callWithCatch({
      url: tourneyUrl('/emails'),
      method: 'get',
      onSuccess: data => {
        // form.setFieldsValue({division_ids: data.divisions.map(d => d.id)});
        setDivs(data.divisions);
      }
    })
  }, []);

  const players_type = Form.useWatch('players_type', form);
  const division_ids = Form.useWatch('division_ids', form);
  const teams_type = Form.useWatch('teams_type', form);

  useEffect(() => {
    callWithCatch({
      setLoading,
      url: tourneyUrl('/emails'),
      method: 'post',
      params: { players_type, division_ids, teams_type },
      onSuccess: data => {
        setPlayers(data.players);
      }
    })
  }, [players_type, division_ids, teams_type]);


  // --- Table Columns ---
  const columns = [
    {title: 'Name', dataIndex: 'name', key: 'name'},
    {title: 'Email', dataIndex: 'email', key: 'email'},
  ];

  return (
    <Row gutter={[24, 16]}> {/* Increased gutter */}

      {/* Column 1: Email Compose Area */}
      <Col xs={24} lg={12}>
        <div className="space-y-4">
          <Space>
            <Radio.Group optionType="button" buttonStyle="solid"
                         value={isTestMode ? 'test' : 'players'}
                         onChange={v => setIsTestMode(v.target.value === "test")}>
              <Radio value="players">Send to Players</Radio>
              <Radio value="test">Send to Yourself (Test)</Radio>
            </Radio.Group>
          </Space>
          <Form.Item name="subject" label="Subject" rules={[{required: true}]}>
            <Input
              autoFocus
              placeholder="Email Subject"
            />
          </Form.Item>
          <Form.Item name="body" label="Body" rules={[{required: true}]}>
            <BoldLinkOnlyEditor />
          </Form.Item>
          <Showable v={!isTestMode}>
            <div className="grid grid-cols-2 gap-8">
              <div>
                <Form.Item name="division_ids" label="Divisions Filter" rules={[{required: true}]}>
                  <SelectableTable data={divs} columns={[{
                    title: 'Divisions',
                    dataIndex: 'name',
                  }]}/>
                </Form.Item>
              </div>
              <div>
                <Switch2 v={Tourney.excel}>
                  <div>
                    <Form.Item name="players_type" label="Players Filter" rules={[{required: true}]}>
                      <Radio.Group size="large">
                        <Radio value="all">All Players</Radio>
                        <Radio value="confirmed">Only Confirmed</Radio>
                        <Radio value="pending">Only Pending</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item name="players_type" label="Players Filter" rules={[{required: true}]}>
                      <Radio.Group size="large">
                        <Radio value="all">All Players</Radio>
                        <Radio value="captains">Only Captains</Radio>
                        <Radio value="all_teams">Players on Teams</Radio>
                        <Radio value="waitlist">Players on Waitlist</Radio>
                      </Radio.Group>
                    </Form.Item>
                    <br/>
                    <Showable v={players_type !== "waitlist"}>
                      <Form.Item name="teams_type" label="Teams Filter" rules={[{required: true}]}>
                        <Radio.Group size="large">
                          <Radio value="all">All Teams</Radio>
                          <Radio value="confirmed">Only Confirmed</Radio>
                          <Radio value="pending">Only Pending</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Showable>
                  </div>
                </Switch2>
              </div>
            </div>
          </Showable>
        </div>
      </Col>

      {/* Column 2: Controls, Filters, Recipients */}
      <Col xs={24} lg={12}>
        <Space direction="vertical" style={{width: '100%'}} size="middle">
          <Switch2 v={isTestMode}>
            <Card>
              <Text strong style={{marginBottom: 8, display: 'block'}}>
                Send to Yourself
              </Text>
              <Table
                columns={columns}
                dataSource={[{name: gon.user.name, email: gon.user.email}]}
                rowKey="id"
                pagination={false}
                scroll={{y: 480}} // Adjusted scroll height
                size="small"
              />
            </Card>
            <Card>
              <Text strong style={{marginBottom: 8, display: 'block'}}>
                Send to Players ({players.length})
              </Text>
              <Table
                loading={loading}
                columns={columns}
                dataSource={players}
                rowKey="id"
                pagination={false}
                scroll={{y: 480}} // Adjusted scroll height
                size="small"
              />
            </Card>
          </Switch2>
        </Space>
      </Col>
    </Row>
  );
}


let EmailModal = NiceModal.create(observer(({}) => {
 const [form] = Form.useForm();

  const division_ids = Form.useWatch('division_ids', form);

  let send = async (params) => {
    await callWithCatch({
      url: tourneyUrl('/emails'),
      method: 'post',
      params: {send: true, ...params},
      onSuccess: () => {
        if (division_ids) {
          notification.success({message: "Emails Sent"});
          NiceModal.remove(EmailModal);
        }
        else
          notification.success({message: "Test Email Sent"});
      }
    })
  }


  return <NiceModalForm top width={1000} okText="Send Email" onSave={send} title="Email Players"
                        form={form}
                        initialValues={{teams_type: 'all', players_type: "all", division_ids: []}}>
    <EmailTool form={form}/>
  </NiceModalForm>
}))

export default EmailModal;